/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React, { useEffect, useState } from "react";
import { RichTextComponent } from "cms/components/rich-text/rich-text";
import { SimpliCityAdminSDK } from "@simplicitycms/simplicity-admin-js-sdk";
import { useAuth } from "cms/auth/hooks/useAuth";
import { ButtonCtaItem } from "./button-cta-item";

const ButtonCtaComponent = (props) => {
    const { token } = useAuth();
    const { component } = props;
    const title = component.title;
    const subtitle = component.subtitle;
    const description = component.description;
    const links_guids = component.links || [];
    const linkProperties = component?.linkProperties ?? {};
    console.log("linkProperties::", linkProperties);
    const [links, setLinks] = useState([]);
    const [loadingLinks, setLoadingLinks] = useState(false);

    // const onClickLink = (link) => {
    //     window.open(link?.url, "_blank");
    // };

    useEffect(() => {
        const getLinks = async () => {
            if (links_guids.length === 0) {
                return;
            }

            try {
                setLoadingLinks(true);
                const loadedLinks = await Promise.all(
                    links_guids.map((linkGuid) =>
                        SimpliCityAdminSDK.link.findOne(token, linkGuid)
                    )
                );
                setLinks(loadedLinks);
            } catch (error) {
                console.error("Error loading links:", error);
            } finally {
                setLoadingLinks(false);
            }
        };
        getLinks();
    }, [links_guids, token]);

    return (
        <div className="button-cta-container">
            <div className="button-cta-content">
                <div className="button-cta-title">
                    <h2 className="button-cta-title-main">{title}</h2>
                    <h2 className="button-cta-title-subtitle">{subtitle}</h2>
                </div>
                <div className="button-cta-description">
                    <RichTextComponent component={{ richtext: description }} />
                </div>
                <div className="button-cta-links">
                    {loadingLinks ? (
                        <div className="button-cta-loading">Loading...</div>
                    ) : (
                        links.map((link, index) => {
                            const linkGuid = link?.guid;
                            const specificLinkProperties = linkProperties[linkGuid] || {};

                            return (
                                <ButtonCtaItem
                                    key={index}
                                    link={link}
                                    linkProperties={specificLinkProperties}
                                />
                            );
                        })
                    )}
                </div>
            </div>
        </div>
    );
};

ButtonCtaComponent.displayName = "ButtonCtaComponent";
export { ButtonCtaComponent };

